























































import Webview from '@/webview';

import { SPECIALIST_DETAIL } from '@/constant';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

import { IspecialistDetail } from '@/store/specialist/index.d';
import { commitSetSetSpecialistDetail } from '@/store/specialist';

@Component
export default class Specialists extends Webview {
  @Prop({
    type: Array,
    default: () => []
  })
  specialists!: IspecialistDetail[];

  @Prop({
    type: String
  })
  goSpecialistsEvent!: string;

  goSpecialistDetail(detail: IspecialistDetail): void {
    const { doctorId } = detail;
    if (this.goSpecialistsEvent) {
      this.telescope.trackEvent({ trackId: this.goSpecialistsEvent, custom: { doctorId } });
    }
    commitSetSetSpecialistDetail(this.$store, detail);
    this.$router.push(`${SPECIALIST_DETAIL}/${doctorId}`);
  }
}
